export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-underline-edfda0a6d6a105707ab20beec29cf4a0.svg";